import { gql } from 'graphql-tag'

export default gql`
  fragment ModuleNavigationLinkFragment on ModuleNavigationLink {
    sys {
      id
    }
    title
    text
    openInNewWindow
    externalLink
    internalLink {
      ... on Entry {
        sys {
          id
        }
        contentType: __typename
      }
      #      ... on PageCareersFormula {
      #        sys {
      #          id
      #        }
      #        contentType: __typename
      #      }
    }
  }
`
